<template>
    <div class="content daily" v-if="leftTime >= 0">
        <Loading v-if="loading"/>
        <template v-else>
            <Ques
                v-if="questions.length && !showUserRes && !results.length"
                :questions="questions"
                @submit="handleSubmit"
            />
            <Res
                v-if="showUserRes && userResult.result_id"
                :result="userResult"
                @getQuesRes="getQuesRes"/>

            <Analysis
                v-if="!showUserRes && results.length"
                :results="results"
                @getQuesRes="getQuesRes"
                @showUserRes="changeShowUserRes"
                />
        </template>

    </div>
</template>

<script>
import { Loading, Toast } from 'vant';
import { objToList, arrRenameKey } from '@/utils/func';
import { quizsGet, quizResultsPost, quizResultResultIdGet } from '@/apis/quiz';
import { userApi } from '@/apis'
import Res from './components/Res'
import Ques from './components/Ques'
import Analysis from './components/Analysis'
export default {
    components: {
        Ques,
        Res,
        Analysis,
        Loading
    },
    watch: {
        user() {
            this.getQues()
        }
    },
    computed: {
        leftTime () {
            return this.maxDailyTime - (this.user.daily_quiz_times || 0)
        }
    },
    data() {
        return {
            maxDailyTime: 0,
            loading: true,
            user: {},
            showUserRes: false,
            questions:[],
            userResult: {},
            results:[]
        };
    },
    async mounted() {
        await this.getConfig()
        this.getInfo()
    },
    methods: {
        async getConfig () {
            Object.assign(this, await this.GLOBAL.getConfig('maxDailyTime'))
        },
        async getInfo () {
            const logined = await this.$auth.check()
            if (logined) {
                const { body } = await userApi.userUidGet({
                    params: {
                        uid: logined
                    }
                })
                this.user = body
                if (this.leftTime <= 0) {
                    Toast.fail({
                        message: `今日答题次数用完啦，明天记得回来看看\n\n还可以去“北京市公民科学素质大赛”答题哦`,
                        duration: 2000,
                        onClose: () => {
                            this.location.replace('/quiz')
                        }
                    })
                }
            }

        },
        async getQues() {
            const {
                query: {
                    grade = 1,
                }
            } = this.$route || {}
            try {
                const {body} = await quizsGet({
                    params: {
                        quiz_difficulty: grade,
                        category: 'sun',
                        quiz_type: 'sun_daily',
                        limit: 10
                    }
                })
                this.questions = body
                this.loading =false
            } catch (error) {
                console.log(error)
                this.loading =false
                this.location.replace('/quiz')
            }
        },
        async handleSubmit(answers) {
            this.loading = true
            try {
                const {
                    body
                } = await quizResultsPost({
                    body: {
                        quiz_type: 'sun_daily',
                        is_add_score: true,
                        user_quizs: arrRenameKey(objToList(answers, 'quiz_id', (val) => parseInt(val)), {seq_id: 'answer_seq_num'})
                    }
                })

                this.userResult = body
                this.changeShowUserRes(true)
                this.loading =false
            } catch (error) {
                console.log(error)
                this.loading =false
                this.location.replace('/quiz')
            }
        },
        async getQuesRes() {
            this.changeShowUserRes(false)

            if (this.results.length) return

            this.loading = true
            try {
                const {
                    body
                } = await quizResultResultIdGet({
                    params: {
                        resultId: this.userResult.result_id
                    }
                })

                this.results = body
                this.loading =false
            } catch (error) {
                console.log(error)
                this.loading =false
                this.location.replace('/quiz')
            }
        },
        changeShowUserRes(d) {
            this.showUserRes = d
        }
    }
};
</script>
<style lang="less">
.van-toast {
    width: auto;
    max-width: 75%;
    .van-toast__text {
        white-space: pre;
    }
}
.daily{
    /deep/.van-loading {
        text-align: center;
    }
    .scroll-content{
        margin-top: 15vh;
    }
}
</style>
